import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as productsActions from '../../actions/productsActionCreators';
import {Link, withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import constants from '../../constants';
import {useMount} from 'react-use';

import SeoTags from '../../routes/SeoTags';
import ComparisonIcon from '../../components/Icons/Comparison';
import ComparisonTable from '../../components/ComparisonTable';

const OffersComparisonPage = (props) => {
  useMount(() => {
    props.productsActions.fetchComparisonOffers();
  });

  return (
    <Layout
      className='articles-page'
      breadcrumbs={[
        {label: 'Сравнение товаров'}
      ]}
    >
      <SeoTags
        controller_action='product_comparison#index'
      />

      <div className='container'>
        <section className='page-content-section'>
          <ComparisonTable
            offers={props.productsState.comparison_offers_data?.offers || []}
            traits={props.productsState.comparison_offers_data?.traits || []}
          />
        </section>
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      productsActions: bindActionCreators(productsActions, dispatch)
    };
  },

  mapStateToProps = ({productsState, railsContext, applicationState}) => {
    return {
      applicationState,
      productsState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(OffersComparisonPage));
